export interface Statistics {
  date: Date;
  dayStat: number;
  dayEnd: number;
  data: any;
}

//TIME: time, time_sent



export abstract class StatisticData {
  abstract getTotalLeads(dateStart,dateEnd, leadTime);
  abstract getTotalLeadsId(dateStart,dateEnd,id,leadTime);
  
  abstract getDayLeadsOffer(dateStart,dateEnd,leadTime);
  abstract getDayLeadsOfferId(dateStart,dateEnd,id,leadTime);
  
  abstract getTotalLeadsOffer(dateStart,dateEnd,leadTime);
  abstract getTotalLeadsOfferId(dateStart,dateEnd,id,leadTime);
  
  abstract getDayLeadsRef(dateStart,dateEnd,leadTime);
  abstract getDayLeadsRefId(dateStart,dateEnd,id,leadTime);

  abstract getDayLeadsCampaign(dateStart,dateEnd,leadTime);
  abstract getDayLeadsCampaignId(dateStart,dateEnd,id,leadTime);
}
